export default __webpack_public_path__ + "img/7987122ee9a40b172b09595fbb71eace.png";